"use client"
/* */
import { jsx } from 'react/jsx-runtime';
import formFieldStyles from '../FormField/FormField.module.scss.mjs';
import { useFormValidation } from '@react-aria/form';
import { useFormValidationState } from '@react-stately/form';
import { InputContext, FieldErrorContext } from 'react-aria-components';
import { FileInput } from './components/FileInput.mjs';
import { flowComponent } from '../../lib/componentFactory/flowComponent.mjs';
import '../../lib/propsContext/propsContext.mjs';
import 'react';
import '../../lib/viewComponentContext/viewComponentContext.mjs';
import { PropsContextProvider } from '../../lib/propsContext/PropsContextProvider.mjs';
import { useObjectRef } from '@react-aria/utils';
import { addAwaitedArrayBuffer } from '../../../../core/src/file.mjs';

const FileField = flowComponent("FileField", (props) => {
  const {
    children,
    ref,
    isRequired,
    isInvalid,
    isDisabled,
    validationBehavior,
    onChange,
    ...restInputProps
  } = props;
  const inputRef = useObjectRef(ref);
  const formValidationState = useFormValidationState({
    value: void 0,
    validationBehavior,
    isInvalid
  });
  useFormValidation({ validationBehavior }, formValidationState, inputRef);
  const inputProps = {
    ...restInputProps,
    ref: inputRef,
    "aria-invalid": formValidationState.displayValidation.isInvalid,
    value: void 0
  };
  const propsContext = {
    Label: {
      className: formFieldStyles.label,
      optional: !props.isRequired
    },
    FieldDescription: {
      className: formFieldStyles.fieldDescription
    },
    FieldError: {
      className: formFieldStyles.customFieldError
    }
  };
  const handleOnChange = (fileList) => {
    if (fileList && onChange) {
      Promise.all(Array.from(fileList).map(addAwaitedArrayBuffer)).then(
        () => onChange(fileList)
      );
    }
  };
  return /* @__PURE__ */ jsx(InputContext.Provider, { value: inputProps, children: /* @__PURE__ */ jsx(FieldErrorContext.Provider, { value: formValidationState.displayValidation, children: /* @__PURE__ */ jsx(PropsContextProvider, { props: propsContext, children: /* @__PURE__ */ jsx(
    "div",
    {
      "data-required": !!isRequired || void 0,
      "data-invalid": formValidationState.displayValidation.isInvalid || void 0,
      className: formFieldStyles.formField,
      children: /* @__PURE__ */ jsx(
        FileInput,
        {
          ref,
          onChange: handleOnChange,
          isDisabled,
          children
        }
      )
    }
  ) }) }) });
});

export { FileField, FileField as default };
//# sourceMappingURL=FileField.mjs.map
